export enum UpsMasterShipmentTypes {
    LIST_LOADING = "UPS_MASTER_LIST_LOADING",
    LIST_SUCCESS = "UPS_MASTER_LIST_SUCCESS",
    LIST_FAILURE = "UPS_MASTER_LIST_FAILURE",

    DETAIL_LOADING = "UPS_MASTER_DETAIL_LOADING",
    DETAIL_SUCCESS = "UPS_MASTER_DETAIL_SUCCESS",
    DETAIL_FAILURE = "UPS_MASTER_DETAIL_FAILURE",

    ACTION_LOADING = "UPS_MASTER_ACTION_LOADING",
    ACTION_SUCCESS = "UPS_MASTER_ACTION_SUCCESS",
    ACTION_FAILURE = "UPS_MASTER_ACTION_FAILURE",

    SET_SELECTED = "UPS_MASTER_SET_SELECTED",
    SET_STATUS_FILTER = "UPS_MASTER_SET_STATUS_FILTER",
}
